var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProdTime06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prodTime06",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.5,
    height: 33.437,
    viewBox: "0 0 30.5 33.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time-forward-ten"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M27.5,2.5V6.7A15,15,0,1,0,15,30V27.5A12.5,12.5,0,1,1,25.829,8.75H21.248v2.5H27.5A2.5,2.5,0,0,0,30,8.75V2.5Z",
    transform: "translate(-0.002 0.001)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M14.5,14.75H7v-2.5h5V6h2.5Z",
    transform: "translate(1.747 1.501)",
    fill: "#b7b7b7"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_6",
    "data-name": 6,
    transform: "translate(18.5 29.437)",
    fill: "#b7b7b7",
    fontSize: 20,
    fontFamily: "TTDongwhacaekR, '\\\\\\\\32 10 Dongwhacaek'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdTime06);
export default __webpack_public_path__ + "static/media/prodTime06.3db3e82947923b5e411cd4e6eaec4052.svg";
export { ForwardRef as ReactComponent };